module.exports = __webpack_public_path__ + "e0106718/img/cadBim.e369a02a.png";